import { type BlankImageData, BlankSingleSideEnum } from "../../interfaces/blank";
import { CustomizationImageKind, type ICustomizationDetails } from "../../interfaces/customization";

export const getCustomizationImageSrc = (customization: ICustomizationDetails, side: BlankSingleSideEnum) =>
  customization.images?.find((item) => item.kind === CustomizationImageKind.PRINT && item.side === side)?.imageUrl ??
  customization.images?.find((item) => item.kind === CustomizationImageKind.LOW_QUALITY_PREVIEW && item.side === side)
    ?.imageUrl ??
  "";

export const getCustomizationImageData = ({
  blankImage,
  customization,
  side,
}: {
  blankImage?: BlankImageData;
  customization?: ICustomizationDetails;
  side: BlankSingleSideEnum;
}) => {
  if (!customization || !blankImage) {
    return undefined;
  }

  const productionPrint = customization.images?.find(
    (item) => item.kind === CustomizationImageKind.PRINT && item.side === side,
  );
  const hasLowQualityImage = customization.images?.some(
    (item) => item.kind === CustomizationImageKind.LOW_QUALITY_PREVIEW && item.side === side,
  );
  const productionPlacement = (() => {
    if (!productionPrint) {
      return undefined;
    }

    const { widthCm, heightCm, offsetXMillimeters, offsetYMillimeters, printAreaWidthCm, printAreaHeightCm } =
      productionPrint;
    if (
      widthCm === undefined ||
      heightCm === undefined ||
      offsetXMillimeters === undefined ||
      offsetYMillimeters === undefined ||
      printAreaWidthCm === undefined ||
      printAreaHeightCm === undefined
    ) {
      return undefined;
    }

    return {
      left: (offsetXMillimeters / (printAreaWidthCm * 10)) * 100,
      top: (offsetYMillimeters / (printAreaHeightCm * 10)) * 100,
      width: (widthCm / printAreaWidthCm) * 100,
      height: (heightCm / printAreaHeightCm) * 100,
    };
  })();

  return {
    area: hasLowQualityImage ? customization.details?.[side]?.area : undefined,
    imageSrc: getCustomizationImageSrc(customization, side),
    printArea: blankImage.printArea,
    productionPlacement,
  };
};
